import { FetchPolicy } from "@apollo/client";
import { get } from "lodash";
import { format } from "date-fns";
import { formatBets } from "@fdr/utils/BetUtils";
import type { Props } from "../types";

export const getVariables = (props: Props) => {
  const startDate = new Date();

  return {
    trackCode: props.trackAbbr,
    raceNumber: props.raceNumber,
    startDate: format(startDate, "yyyy-MM-dd"),
    endDate: format(startDate, "yyyy-MM-dd"),
    accountId: parseInt(props.accountNumber, 10)
  };
};

export default {
  skip: (props: Props) => !props.accountNumber,
  options: (props: Props) => {
    const poll = get(props, "hasWebSockets", false)
      ? {}
      : { pollInterval: 30000 };

    return {
      ...poll,
      fetchPolicy: "cache-and-network" as FetchPolicy,
      client: props.behgClient,
      ssr: false,
      variables: getVariables(props)
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props: (result: any) => ({
    userRaceBets: formatBets(get(result, "data.wagerHistory.wagers", [])),
    isLoading: result.data.loading,
    subscribeToMoreBets:
      get(result, "ownProps.hasWebSockets", false) && !result.data.loading
        ? result.data.subscribeToMore
        : null
  })
};
